import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { CapicheLoggerService } from 'capiche-logger';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const logger = new CapicheLoggerService('auth.guard:', false);

  return authService.authState$.pipe(
    take(1),
    map((user) => {
      logger.log('authState$ user:', user);
      if (!user) {
        logger.log('authState$ no user: redirecting to /auth');
        return router.parseUrl('/auth');
      }
      logger.log('authState$ user:', user, 'allowing access to the route');
      return true;
    }),
  );
};
